import { render, staticRenderFns } from "./advisory-start.vue?vue&type=template&id=dd673b26&"
import script from "./advisory-start.vue?vue&type=script&lang=js&"
export * from "./advisory-start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports